import React from "react";
import "./Projects.css";
import { Button, Text } from "@chakra-ui/react";
import {
  SiHtml5,
  SiJavascript,
  SiReact,
  SiRedux,
  SiSelenium,
  SiCypress,
  SiCucumber,
  SiWebdriverio,
  SiPostman,
  SiJava,
  SiJira,
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { IoShieldCheckmark } from "react-icons/io5";
import { RiLiveFill } from "react-icons/ri";
import { FaGithub, FaJenkins } from "react-icons/fa";
import lifestyle from "../Projects/lifestyle.png";
import Banjara from "../Projects/Banjara.png";
import KhanAcademy from "../Projects/KhanAcademy.jpg";
import GithubRA from "../Projects/GithubRA.png";
import Karnataka from "../Projects/Karnataka.png";

export const Projects = () => {
  return (
    <div id="Projects">
      <hr />
      <br />
      <div className="section">
        <Text
          borderRadius={"20px"}
          as="b"
          fontSize={{ base: "18px", md: "24px", lg: "36px" }}
          style={{ textShadow: "#FC0 1px 0 10px" }}
          className="section__title_different"
        >
          ##Projects
        </Text>
        <br />
        <br />
        {/* <p className="section__title_different">recently worked on:-</p> */}
        <div className="allProjects">
          {/* 1st */}

          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img src={lifestyle} alt="Lifestyle Store - eCommerce" />
                </div>
              </div>
              <div className="project_information">
                <h2>“LifeStyle Store”.</h2>
                <p>
                  Lifestyle is India's leading fashion destination for the
                  latest trends with multiple categories including men, women
                  and kids’ apparel, footwear, handbags, fashion accessories and
                  beauty under the convenience of a single roof.
                </p>
                <br />
                <p>
                  <b>Responsibilities</b>

                  <p>1. Project representative.</p>
                  <p>
                    2. Worked on the client side, preparing Gherkin (BDD)
                    scenarios.
                  </p>
                  <p>3. Automated test cases using Cypress and JavaScript.</p>
                  <p>4. Generated Mochawesome report.</p>
                </p>
                <br />
                <div className="project_stack">
                  <SiCypress size={40} />
                  <SiCucumber size={40} />
                  <SiJavascript size={40} />
                </div>

                <br />
                <div>
                  <a
                    href="https://inspiring-empanada-77b05a.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Button type="button" className="btns onbt onbt">
                      View REPORT-- <RiLiveFill />
                    </Button>
                  </a>
                  <a
                    href="https://github.com/Shubhamverma94/LifeStyle-Store/tree/main"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Button type="button" className="btns onbt">
                      Source CODE-- <FaGithub />
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* 2nd */}

          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img src={KhanAcademy} alt="KhanAcademy" />
                </div>
              </div>
              <div className="project_information">
                <h2>“Khan Academy”.</h2>
                <p>
                  Khan Academy is a non-profit educational organization. The
                  Khan Academy Mobile Testing App is a free tool that allows you
                  to test the functionality of the Khan Academy mobile app on a
                  variety of devices and operating systems.
                </p>
                <br />
                <p>
                  <b>Responsibilities</b>

                  <p>1. Project representative.</p>
                  <p>
                    2. Configuration of Android emulator for the KhanAcademy app
                    using Appium.
                  </p>
                  <p>
                    3. Automation of test cases using Cypress and JavaScript.
                  </p>
                  <p>4. Generation of Allure report.</p>
                </p>
                <br />
                <div className="project_stack">
                  <SiCypress size={40} />
                  <SiWebdriverio size={40} />
                  <SiJavascript size={40} />
                </div>

                <br />
                <div>
                  <a
                    href="https://venerable-basbousa-6f99d5.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Button type="button" className="btns onbt onbt">
                      View REPORT-- <RiLiveFill />
                    </Button>
                  </a>
                  <a
                    href="https://github.com/Shubhamverma94/KhanAcademy-POM-MT"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Button type="button" className="btns onbt">
                      Source CODE-- <FaGithub />
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* 3nd */}

          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img src={GithubRA} alt="Github Rest Assured" />
                </div>
              </div>
              <div className="project_information">
                <h2>“Github API”.</h2>
                <p>
                  GitHub API is a web interface for developers to
                  programmatically interact with GitHub, offering endpoints for
                  tasks like repository management, user information access,
                  issue handling, and workflow integration.
                </p>
                <br />
                <p>
                  <b>Responsibilities</b>

                  <p>1. Project representative.</p>
                  <p>
                    2. Implementation of test cases using the Rest Assured
                    framework.
                  </p>
                  <p>3. Creation of data-driven test cases on Postman.</p>
                  <p>4. Execution of Postman collection on Jenkins.</p>
                  <p>5. Generation of Newman report.</p>
                </p>
                <br />
                <div className="project_stack">
                  <SiSelenium size={40} />
                  <IoShieldCheckmark size={40} />
                  <SiPostman size={40} />
                  <FaJenkins size={40} />
                </div>

                <br />
                <div>
                  <a
                    href="https://willowy-yeot-8ac28e.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Button type="button" className="btns onbt onbt">
                      View REPORT-- <RiLiveFill />
                    </Button>
                  </a>
                  <a
                    href="https://github.com/Shubhamverma94/RA_GithubAPI"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Button type="button" className="btns onbt">
                      Source CODE-- <FaGithub />
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* /* 4nd */}

          <div className="projects_container" data-aos="fade-right">
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img src={Karnataka} alt="Karnataka Tourism" />
                </div>
              </div>
              <div className="project_information">
                <h2>“Karnataka Tourism”.</h2>
                <p>
                  Karnataka Tourism website showcases the cultural heritage,
                  natural beauty, and attractions of Karnataka, India, providing
                  visitors with essential travel information and inspiring them
                  to explore the diverse destinations within the state.
                </p>
                <br />
                <p><b>Responsibilities:</b>
                <p>1. Created a Mind Map using X-MindMap.</p>
                <p>2. Created issues on Jira using Zephyr.</p>
                <p>3. Developed manual test cases on Google Sheets.</p>
                <p>4. Executed automation test cases using Selenium Java.</p>
                <p>
                  5. Created summary reports to summarize testing results and
                  findings.
                </p></p>
                <br />
                <div className="project_stack">
                  <SiSelenium size={40} />
                  <SiJava size={40} />
                  <SiJira size={40} />
                  {/* < size={40} /> */}
                </div>
                
                <br />
                <div>
                  <a
                    href="https://docs.google.com/document/d/1vaulc44zLcZUopum3Fer0nKxMcsVEpgFAaOzcSp4oU8/edit?usp=sharing"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Button type="button" className="btns onbt onbt">
                      View REPORT-- <RiLiveFill />
                    </Button>
                  </a>
                  <a
                    href="https://github.com/Shubhamverma94/Karnataka_Tourism"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Button type="button" className="btns onbt">
                      Source CODE-- <FaGithub />
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
